import React from "react";
import { Box, CardContent, Grid, Typography } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import SpeedRoundedIcon from "@mui/icons-material/SpeedRounded";

function FeaturesSection() {
  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      <Grid item xs={12} sm={4}>
        <Box sx={{ textAlign: "center", p: 3 }}>
          <CheckCircleRoundedIcon
            sx={{ fontSize: 48, color: "success.main", mb: 1 }}
          />
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
            Gratuito
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Nessun costo nascosto
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Box sx={{ textAlign: "center", p: 3 }}>
          <ShieldRoundedIcon
            sx={{ fontSize: 48, color: "primary.main", mb: 1 }}
          />
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
            Sicuro
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Dati protetti e criptati
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Box sx={{ textAlign: "center", p: 3 }}>
          <SpeedRoundedIcon
            sx={{ fontSize: 48, color: "warning.main", mb: 1 }}
          />
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
            Veloce
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Preventivo in 5 minuti
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
}

export default FeaturesSection;
